export default __webpack_public_path__ + "icon-social-media-twitter-rollover.4a613c939b87a6fa887e.svg";